<template>
    <img src="../assets/svg/logo.svg">
</template>

<script>
export default {
    name: 'AppLogo'
}
</script>

<style lang="scss" scoped></style>